import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cdcf64ee")

_pushScopeId("data-v-cdcf64ee")
const _hoisted_1 = { class: "scenarioConstruction" }
const _hoisted_2 = { class: "scenarioConstruction-container flex justify-between" }
const _hoisted_3 = { class: "sc-steps fff bdra4" }
const _hoisted_4 = { class: "sc-main" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_step = _resolveComponent("a-step")
  const _component_a_steps = _resolveComponent("a-steps")
  const _component_roleInfo = _resolveComponent("roleInfo")
  const _component_dialogueInfo = _resolveComponent("dialogueInfo")
  const _component_articleInfo = _resolveComponent("articleInfo")
  const _component_deduceSetting = _resolveComponent("deduceSetting")
  const _component_riskAnalysis = _resolveComponent("riskAnalysis")
  const _component_deduceAnalysis = _resolveComponent("deduceAnalysis")
  const _component_taskList = _resolveComponent("taskList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_a_steps, {
          direction: "vertical",
          current: _ctx.sceneConstructModule.stepIndex,
          onChange: _ctx.controllerModule.stepsChange
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneConstructModule.steps, (item) => {
              return (_openBlock(), _createBlock(_component_a_step, {
                key: item.value,
                title: item.title,
                status: _ctx.controllerModule.getStepStatus(item.value)
              }, null, 8, ["title", "status"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["current", "onChange"])
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.sceneConstructModule.stepIndex === 0)
          ? (_openBlock(), _createBlock(_component_roleInfo, {
              key: 0,
              headerText: _ctx.controllerModule.stepName.value,
              caseId: _ctx.sceneConstructModule.caseId,
              onNextStep: _ctx.controllerModule.nextStep,
              onSaveStep: _ctx.controllerModule.saveStep
            }, null, 8, ["headerText", "caseId", "onNextStep", "onSaveStep"]))
          : _createCommentVNode("", true),
        (_ctx.sceneConstructModule.stepIndex === 1)
          ? (_openBlock(), _createBlock(_component_dialogueInfo, {
              key: 1,
              headerText: _ctx.controllerModule.stepName.value,
              caseId: _ctx.sceneConstructModule.caseId,
              onNextStep: _ctx.controllerModule.nextStep,
              onSaveStep: _ctx.controllerModule.saveStep
            }, null, 8, ["headerText", "caseId", "onNextStep", "onSaveStep"]))
          : _createCommentVNode("", true),
        (_ctx.sceneConstructModule.stepIndex === 2)
          ? (_openBlock(), _createBlock(_component_articleInfo, {
              key: 2,
              headerText: _ctx.controllerModule.stepName.value,
              onNextStep: _ctx.controllerModule.nextStep,
              onSaveStep: _ctx.controllerModule.saveStep
            }, null, 8, ["headerText", "onNextStep", "onSaveStep"]))
          : _createCommentVNode("", true),
        (_ctx.sceneConstructModule.stepIndex === 3)
          ? (_openBlock(), _createBlock(_component_deduceSetting, {
              key: 3,
              headerText: _ctx.controllerModule.stepName.value,
              onNextStep: _ctx.controllerModule.nextStep,
              onSaveStep: _ctx.controllerModule.saveStep
            }, null, 8, ["headerText", "onNextStep", "onSaveStep"]))
          : _createCommentVNode("", true),
        (_ctx.sceneConstructModule.stepIndex === 4)
          ? (_openBlock(), _createBlock(_component_riskAnalysis, {
              key: 4,
              headerText: _ctx.controllerModule.stepName.value,
              onNextStep: _ctx.controllerModule.nextStep,
              onSaveStep: _ctx.controllerModule.saveStep
            }, null, 8, ["headerText", "onNextStep", "onSaveStep"]))
          : _createCommentVNode("", true),
        (_ctx.sceneConstructModule.stepIndex === 5)
          ? (_openBlock(), _createBlock(_component_deduceAnalysis, {
              key: 5,
              headerText: _ctx.controllerModule.stepName.value,
              onNextStep: _ctx.controllerModule.nextStep,
              onSaveStep: _ctx.controllerModule.saveStep
            }, null, 8, ["headerText", "onNextStep", "onSaveStep"]))
          : _createCommentVNode("", true),
        (_ctx.sceneConstructModule.stepIndex === 6)
          ? (_openBlock(), _createBlock(_component_taskList, {
              key: 6,
              headerText: _ctx.controllerModule.stepName.value,
              onNextStep: _ctx.controllerModule.nextStep,
              onSaveStep: _ctx.controllerModule.saveStep
            }, null, 8, ["headerText", "onNextStep", "onSaveStep"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})